import { Component, AfterViewInit, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { AuthenticationService } from '../../../authentication.service';
import { ProfileService } from '../../../portal/service/profile.service';
import { MainService as portal_mainService } from '../../../portal/service/main.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import {session} from '../../../../environments/environment.session'
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';

@Component({
  selector: '[app-accounts-header]',
  templateUrl: './accounts-header.component.html',
  styleUrls: ['./accounts-header.component.css']
})
export class AccountsHeaderComponent implements OnInit {

  constructor(public auth: AuthenticationService, private router: Router, public portal_main: portal_mainService,
    public mainService: MainService,private utf8EncodingService:Utf8EncodingService, private profileService: ProfileService, private sanitizer: DomSanitizer) { }

  erpUser: any = {};
  async ngOnInit() {
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    await this.portal_main.getUserImage(this.erpUser['user_id']);
    await this.portal_main.getAccImage(this.erpUser['b_acct_id']);
    await this.portal_main.getAccountInfo(this.erpUser['b_acct_id']);
    await this.portal_main.getHeaderInfo(this.erpUser['b_acct_id']);
    await this.changeLanguage();
    this.mainService.accInfo = this.portal_main.accInfo;
  }

  changeLanguage() {
    this.mainService.language_cd = this.auth.language_cd
  }

  home() {
    this.router.navigate(['/index'])
  }

  ngAfterViewInit() {
  }


  async logOut(){
    sessionStorage.removeItem("1001");
    sessionStorage.removeItem("1000");
    sessionStorage.removeItem("1005");
    session.erpUser = undefined
    this.router.navigate(['/login']);
}


}
